<template>
    
    <div id="searchPageWrapper">
        <section  class="top">
            <div class="top-container titles">
                    <h1 key="h11" v-if="!serachTitleNoResults">{{ $t('search_results_for') }}: {{ hash.substr(1) }}</h1>
                
                    <h1 key="h1" v-if="serachTitleNoResults">{{ $t('nothing_found') }}</h1>
                    <p key="p" v-if="serachTitleNoResults">{{ $t('nothing_found_subtitle') }}</p>
                
                <form role="search" class="search-no-results">
                    <label>
                        <!-- <span class="screen-reader-text">Search for:</span> -->
                        <input type="search" class="search-field" :placeholder="$t('search_placeholder')" value="adsasda" name="s" v-model="search" @keyup="updateHash(search)">
                    </label>
                </form>
            </div>
        </section>
        <section class="categories">
            <div class="container container-tight accordion" id="searchResults">
                <router-link tag="a" :to="'/' + this.$route.params.lang" class="return">
                    <i class="ipic_arrow-l"></i>
                    <span>{{ $t('back_button') }}</span>
                </router-link>
                <div class="categories-content-row" id="mainWrapperQuestions" ref="app">
                        <div class="loading_wrapper" v-if="visible_spinner">
                            <div class="spinner-block" >
                                <div class="spinner-grow"  role="status">
                                    <span class="sr-only">{{ $t('loading') }}</span>
                                </div>
                            </div>
                        </div>
                        <transition-group enter-active-class="fadeIn" leave-active-class="fadeOut" mode="out-in" tag="div" class="categories-content accordion" id="accordionSearchPage"  data-parent="#searchResults">
                            <div class="cat-block-pr" v-for="(question, index) in questions" :key="'key' + index"  :id="question.post_slug" style="animation-duration: 0.2s" >
                                <div class="categories-content-blocks" :id="question.post_slug">
                                    <a class="categories-content-expand question_search_link" @click.prevent="scrollToElement" data-toggle="collapse" :data-id="question.post_slug" :data-target="'#collapse-' + question.post_slug" role="button" aria-expanded="false" :aria-controls="'#' + question.post_slug">
                                        <span :data-id="question.post_slug">{{ question.post_title }}</span>
                                        <span class="circle-expand"><i class="ipic_arrow-d"></i></span>
                                    </a>
                                    <div class="collapse" :id="'collapse-' + question.post_slug" data-parent="#accordionSearchPage">
                                        <div class="categories-content-collapsed" v-html="question.content">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition-group>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import i18n from '@/plugins/i18n';
/*eslint-disable */
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    components: {
        PulseLoader,
    },
    /*eslint-enable */
    data: () => {
        return {
            questions: [],
            accountQuestions: "",
            paymentQuestions: "",
            contentQuestions: "",
            search: '',
            serachTitleNoResults: false,
            timeout: null,
            windowHeight: window.innerHeight,
            visible_spinner: false
        }
    },
    mounted () {
        this.populateQuestions();
        this.$store.state.activeCategory = null;
        this.search = this.$route.hash.slice(1);
        window.onresize = () => {
            this.windowHeight = window.innerHeight
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.populateQuestions()
        next()
    },
    computed: {
        hash () {
            return this.$route.hash;
        }
    },
    methods: {
        scrollToElement() {
            let element = "#" + event.target.getAttribute('data-id');
            setTimeout(function(){
                VueScrollTo.scrollTo(element)
            }, 350)
        },
        populateQuestions() {
            let locale = i18n.locale;
            this.visible_spinner = true;
            this.$store.dispatch('getQuestionData',locale)
            .then((res) => {
                this.accountQuestions = res.account
                this.paymentQuestions = res.payment
                this.contentQuestions = res.content
                this.searchFilter()
            })
        },
        updateHash(hash) {
            this.$router.push({
				params: { lang: i18n.locale},
				hash: "#" + hash
			})
        },
        searchFilter () {
            clearTimeout(this.timeout);

            // this.timeout = setTimeout(() => {
                this.questions =[];
                let search = this.$route.hash.substr(1);
                let questionSearch = [];
                let accountQuestions = Object.values(this.accountQuestions);
                let paymentQuestions = Object.values(this.paymentQuestions);
                let contentQuestions = Object.values(this.contentQuestions);
                if(search.length > 0){
                    accountQuestions.forEach(function (item) {
                        if(
                            item.post_title.toLowerCase().trim().includes(search.toLowerCase().trim()) || 
                            item.content.toLowerCase().trim().includes(search.toLowerCase().trim()) ||
                            item.keyword.toLowerCase().trim().includes(search.toLowerCase().trim())
                        ){
                            questionSearch.push(item)
                        } else {
                            item.tag_slug.filter(tag => {
                                if(tag.toLowerCase().trim().includes(search.toLowerCase().trim())){
                                    questionSearch.push(item)
                                }
                            })
                        }
                    });
                    paymentQuestions.forEach(function (item) {
                        if(
                            item.post_title.toLowerCase().trim().includes(search.toLowerCase().trim()) || 
                            item.content.toLowerCase().trim().includes(search.toLowerCase().trim()) ||
                            item.keyword.toLowerCase().trim().includes(search.toLowerCase().trim())
                        ){
                            questionSearch.push(item)
                        } else {
                            item.tag_slug.filter(tag => {
                                if(tag.toLowerCase().trim().includes(search.toLowerCase().trim())){
                                    questionSearch.push(item)
                                }
                            })
                        }
                    });
                    contentQuestions.forEach(function (item) {
                        if(
                            item.post_title.toLowerCase().trim().includes(search.toLowerCase().trim()) || 
                            item.content.toLowerCase().trim().includes(search.toLowerCase().trim()) ||
                            item.keyword.toLowerCase().trim().includes(search.toLowerCase().trim())
                        ){
                            questionSearch.push(item)
                        } else {
                            item.tag_slug.filter(tag => {
                                if(tag.toLowerCase().trim().includes(search.toLowerCase().trim())){
                                    questionSearch.push(item)
                                }
                            })
                        }
                    });
                    this.questions = questionSearch
                    if(questionSearch.length == 0){
                        this.serachTitleNoResults = true;
                    } else {
                        this.serachTitleNoResults = false;
                    }
                }
                let elements = document.getElementsByClassName('collapse ');
                let i;
                for(i=0;i<elements.length;i++){
                    elements[i].classList.remove("show");
                }
                this.visible_spinner = false;
            // }, 500);   
        },
    }
}
</script>

<style scoped>
    /* .top {
        padding: 7% 0 5%;
    } */
    a.return {
        color: #2a4d8e;
        text-transform: uppercase;
        font-size: 18px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0 15px 15px;
    }
    .search-no-results {
        display: flex;
        justify-content: space-evenly;
        align-items: flex-end;
        margin-top: 30px;
    }
    .search-no-results label {
        margin: 0 15px 0 0;
        flex-grow: 2;
    }
    .search-no-results input {
        margin: 0;
        width: auto;
    }
    .search-no-results label input {
        width: 100%;
    }
    .question_search_link {
        cursor: pointer
    }
    .titles {
        position: relative
    }
    #mainWrapperQuestions {
        transition: height 0.2s ease-in;
        position: relative;
    }
    .categories-content {
        display: block;
    }
    .visible {
        visibility: visible;
        opacity: 1;
    }
    .loading_wrapper {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);;
        z-index: 99;
    }
    .spinner-grow {
        width: 3rem;
        height: 3rem;
        background-color: #2a4d8e;
    }
</style>